import { Vehicle } from '../types/catalog';
import { images } from './images';

// Catálogo de demostración. Precios, especificaciones y condiciones deben
// reemplazarse por datos reales desde el panel de administración.
export const vehicles: Vehicle[] = [
  {
    id: 'toyota-corolla-cross-xei',
    brandId: 'toyota',
    model: 'Corolla Cross',
    version: 'XEI 2.0 CVT',
    year: 2027,
    bodyType: 'SUV',
    segment: 'Mediano',
    images: [images.suv, images.suvRear, images.interior],
    price: 42500000,
    availability: 'Disponible',
    engine: 'Nafta 2.0 L',
    transmission: 'Automática CVT',
    consumption: null,
    safety: ['7 airbags', 'Control de estabilidad', 'Frenado autónomo de emergencia'],
    equipment: ['Pantalla táctil con Apple CarPlay / Android Auto', 'Climatizador automático', 'Cámara de retroceso'],
    warranty: 'Según fabricante — a confirmar',
    offer: {
      tna: 39.9,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 45,
      maxFinanceAmount: 24000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota.',
      lender: 'Entidad financiera a confirmar',
      promo: 'Tasa especial para esta versión',
      validUntil: '2026-10-31',
      conditions: 'Promoción sujeta a aprobación crediticia y stock.',
      verified: false,
      updatedAt: '2026-10-06T12:00:00.000Z',
    },
    featured: true,
    published: true,
    updatedAt: '2026-10-06T12:00:00.000Z',
  },
  {
    id: 'toyota-hilux-srx',
    brandId: 'toyota',
    model: 'Hilux',
    version: 'SRX 2.8 TDI 4x4 AT',
    year: 2027,
    bodyType: 'Pick-up',
    segment: 'Grande',
    images: [images.pickup, images.pickupRear, images.interior],
    price: 62000000,
    availability: 'A pedido',
    engine: 'Turbodiésel 2.8 L',
    transmission: 'Automática 6 velocidades',
    consumption: null,
    safety: ['7 airbags', 'Control de estabilidad', 'Asistente de arranque en pendiente'],
    equipment: ['Tracción 4x4', 'Pantalla táctil', 'Tapizado de cuero'],
    warranty: 'Según fabricante — a confirmar',
    offer: null,
    featured: true,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'vw-polo-track',
    brandId: 'volkswagen',
    model: 'Polo',
    version: 'Track 1.6 MSI',
    year: 2027,
    bodyType: 'Hatchback',
    segment: 'Compacto',
    images: [images.hatch, images.hatchSide, images.interior],
    price: 25900000,
    availability: 'Disponible',
    engine: 'Nafta 1.6 L',
    transmission: 'Manual 5 velocidades',
    consumption: null,
    safety: ['Airbags frontales y laterales', 'Control de estabilidad'],
    equipment: ['Radio con Bluetooth', 'Aire acondicionado'],
    warranty: null,
    offer: null,
    featured: true,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'vw-taos-highline',
    brandId: 'volkswagen',
    model: 'Taos',
    version: 'Highline 250 TSI',
    year: 2027,
    bodyType: 'SUV',
    segment: 'Mediano',
    images: [images.suv, images.suvRear, images.interior],
    price: 48300000,
    availability: 'Disponible',
    engine: 'Nafta 1.4 L turbo',
    transmission: 'Automática 6 velocidades',
    consumption: null,
    safety: ['6 airbags', 'Control de estabilidad', 'Alerta de punto ciego'],
    equipment: ['Tablero digital', 'Techo panorámico', 'Climatizador bizona'],
    warranty: 'Según fabricante — a confirmar',
    offer: null,
    featured: false,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'chevrolet-onix-plus-premier',
    brandId: 'chevrolet',
    model: 'Onix Plus',
    version: 'Premier 1.0T AT',
    year: 2027,
    bodyType: 'Sedán',
    segment: 'Compacto',
    images: [images.sedan, images.sedanSide, images.interior],
    price: 31200000,
    availability: 'Disponible',
    engine: 'Nafta 1.0 L turbo',
    transmission: 'Automática 6 velocidades',
    consumption: null,
    safety: ['6 airbags', 'Control de estabilidad'],
    equipment: ['Wi-Fi a bordo', 'Pantalla táctil', 'Cargador inalámbrico'],
    warranty: 'Según fabricante — a confirmar',
    offer: null,
    featured: true,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'chevrolet-tracker-premier',
    brandId: 'chevrolet',
    model: 'Tracker',
    version: 'Premier 1.2T AT',
    year: 2027,
    bodyType: 'SUV',
    segment: 'Compacto',
    images: [images.suv, images.suvRear, images.interior],
    price: 39800000,
    availability: 'A pedido',
    engine: 'Nafta 1.2 L turbo',
    transmission: 'Automática 6 velocidades',
    consumption: null,
    safety: ['6 airbags', 'Control de estabilidad', 'Alerta de colisión frontal'],
    equipment: ['Wi-Fi a bordo', 'Techo panorámico'],
    warranty: null,
    offer: null,
    featured: false,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'renault-kardian-iconic',
    brandId: 'renault',
    model: 'Kardian',
    version: 'Iconic 200 EDC',
    year: 2027,
    bodyType: 'SUV',
    segment: 'Compacto',
    images: [images.suv, images.suvRear, images.interior],
    price: 34000000,
    availability: 'Disponible',
    engine: 'Nafta 1.0 L turbo',
    transmission: 'Automática doble embrague',
    consumption: null,
    safety: ['6 airbags', 'Frenado autónomo de emergencia'],
    equipment: ['Tablero digital', 'Pantalla táctil'],
    warranty: 'Según fabricante — a confirmar',
    offer: null,
    featured: true,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'fiat-cronos-precision',
    brandId: 'fiat',
    model: 'Cronos',
    version: 'Precision 1.3 CVT',
    year: 2027,
    bodyType: 'Sedán',
    segment: 'Compacto',
    images: [images.sedan, images.sedanSide, images.interior],
    price: 27400000,
    availability: 'Disponible',
    engine: 'Nafta 1.3 L',
    transmission: 'Automática CVT',
    consumption: null,
    safety: ['Airbags frontales y laterales', 'Control de estabilidad'],
    equipment: ['Pantalla táctil', 'Cámara de retroceso'],
    warranty: null,
    offer: null,
    featured: false,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  {
    id: 'fiat-titano-freedom',
    brandId: 'fiat',
    model: 'Titano',
    version: 'Freedom 2.2 4x4 AT',
    year: 2027,
    bodyType: 'Pick-up',
    segment: 'Grande',
    images: [images.pickup, images.pickupRear, images.interior],
    price: 45000000,
    availability: 'Sin stock',
    engine: 'Turbodiésel 2.2 L',
    transmission: 'Automática',
    consumption: null,
    safety: ['Airbags frontales y laterales', 'Control de estabilidad'],
    equipment: ['Tracción 4x4', 'Pantalla táctil'],
    warranty: null,
    offer: null,
    featured: false,
    published: true,
    updatedAt: '2026-10-05T10:00:00.000Z',
  },
  // Ejemplos con circular oficial (Jeep, Ram, Citroën). Precios de referencia: reemplazar por los de lista.
  ...circularExamples(),
];

function circularExamples(): Vehicle[] {
  const base = {
    year: 2027,
    consumption: null,
    warranty: null,
    offer: null,
    published: true,
    updatedAt: '2026-10-14T10:00:00.000Z',
  };
  return [
    {
      ...base,
      id: 'jeep-renegade-sport',
      brandId: 'jeep',
      model: 'Renegade',
      version: 'Sport 1.3 T270 AT',
      bodyType: 'SUV',
      segment: 'Compacto',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/bc94f217-5516-4ce1-8a1f-bf10d1bb6e56.jpg', images.interior],
      price: 38500000,
      availability: 'Disponible',
      engine: 'Nafta 1.3 L turbo',
      transmission: 'Automática 6 vel.',
      safety: ['6 airbags', 'Control de estabilidad'],
      equipment: ['Pantalla táctil', 'Apple CarPlay / Android Auto'],
      featured: true,
    },
    {
      ...base,
      id: 'jeep-compass-sport',
      brandId: 'jeep',
      model: 'Compass',
      version: 'Sport 1.3 T270 AT',
      bodyType: 'SUV',
      segment: 'Mediano',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/130e5c1a-7a44-4090-9785-cdc2c2c18435.jpg', images.interior],
      price: 46900000,
      availability: 'Disponible',
      engine: 'Nafta 1.3 L turbo',
      transmission: 'Automática 6 vel.',
      safety: ['6 airbags', 'Control de estabilidad'],
      equipment: ['Pantalla táctil 10"', 'Tablero digital'],
      featured: false,
    },
    {
      ...base,
      id: 'jeep-commander-limited',
      brandId: 'jeep',
      model: 'Commander',
      version: 'Limited 1.3 T270 AT',
      bodyType: 'SUV',
      segment: 'Grande',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/1d7cb858-6ade-44f2-abc9-87b5e08f80b4.jpg', images.interior],
      price: 58900000,
      availability: 'A pedido',
      engine: 'Nafta 1.3 L turbo',
      transmission: 'Automática 6 vel.',
      safety: ['7 airbags', 'Frenado autónomo de emergencia'],
      equipment: ['7 asientos', 'Pantalla táctil 10"'],
      featured: false,
    },
    {
      ...base,
      id: 'ram-rampage-rebel',
      brandId: 'ram',
      model: 'Rampage',
      version: 'Rebel 2.0 Turbo 4x4 AT',
      bodyType: 'Pick-up',
      segment: 'Mediano',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/60c3809e-cf55-4509-bf1e-dbac9a952e9c.jpg', images.interior],
      price: 55900000,
      availability: 'Disponible',
      engine: 'Nafta 2.0 L turbo',
      transmission: 'Automática 9 vel.',
      safety: ['6 airbags', 'Control de estabilidad'],
      equipment: ['Tracción 4x4', 'Pantalla táctil 10"'],
      featured: true,
    },
    {
      ...base,
      id: 'ram-dakota-laramie',
      brandId: 'ram',
      model: 'Dakota',
      version: 'Laramie 2.2 4x4 AT',
      bodyType: 'Pick-up',
      segment: 'Grande',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/f50257a6-299e-4f0a-92a0-b85773ff25ed.jpg', images.pickupRear],
      price: 62500000,
      availability: 'A pedido',
      engine: 'Turbodiésel 2.2 L',
      transmission: 'Automática',
      safety: ['6 airbags', 'Control de estabilidad'],
      equipment: ['Tracción 4x4', 'Pantalla táctil'],
      featured: false,
    },
    {
      ...base,
      id: 'citroen-c3-feel',
      brandId: 'citroen',
      model: 'C3',
      version: 'Feel 1.6 AT',
      bodyType: 'Hatchback',
      segment: 'Compacto',
      images: ['https://cdn.magicpatterns.com/patterns/generated-images/c42e3d91-2eb8-4518-b01d-4a2bf3b25ea6.jpg', images.interior],
      price: 26900000,
      availability: 'Disponible',
      engine: 'Nafta 1.6 L',
      transmission: 'Automática',
      safety: ['Airbags frontales', 'Control de estabilidad'],
      equipment: ['Pantalla táctil 10"', 'Apple CarPlay / Android Auto'],
      featured: true,
    },
  ];
}
